var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomotive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 16.0805C13.8403 16.0805 15.3327 14.5882 15.3327 12.7472C15.3327 10.9063 13.8403 9.41388 11.9993 9.41388C10.1584 9.41388 8.66602 10.9063 8.66602 12.7472C8.66602 14.5882 10.1584 16.0805 11.9993 16.0805Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37333 0 0 5.37333 0 12C0 18.6267 5.37333 24 12 24C18.6267 24 24 18.6267 24 12C24 5.37333 18.6267 0 12 0ZM12 2.66667C16.7333 2.66667 20.6533 6.21333 21.24 10.7867C19.4267 10.96 16.48 11.0933 16 10.2533C14.6667 7.94667 12 8 12 8C12 8 9.33333 7.94667 8 10.2533C7.52 11.0933 4.55997 10.96 2.75997 10.7867C3.35997 6.21333 7.26667 2.66667 12 2.66667ZM3.06665 14.7067C4.69332 14.8667 9.26667 15.8 9.58667 21.0133C6.46667 20.1867 3.98665 17.7867 3.06665 14.7067ZM8 12.7467C8 10.5333 9.78667 8.74667 12 8.74667C14.2133 8.74667 16 10.5333 16 12.7467C16 14.96 14.2133 16.7467 12 16.7467C9.78667 16.7467 8 14.96 8 12.7467ZM14.4133 21.0133C14.7333 15.8133 19.32 14.8667 20.9333 14.7067C20 17.7733 17.52 20.1733 14.4133 21.0133Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomotive);
export default __webpack_public_path__ + "static/media/automotive.7e65d446c412b204d617c73c4eaa3e95.svg";
export { ForwardRef as ReactComponent };